import { LatestNewsState, LatestPostsActions, latestPostTypes } from './latestNews.types'

const INITIAL_STATE: LatestNewsState = {
  latestNews: [],
  error: false,
  loading: false
}

export default (state = INITIAL_STATE, action: LatestPostsActions) => {
  switch (action.type) {
    case latestPostTypes.POST_REQUEST:
      return {
        ...state,
        loading: true
      }
    case latestPostTypes.POST_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        latestNews: action.payload.data
      }
    case latestPostTypes.POST_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        latestNews: []
      }
    default:
      return state
  }
}
